import { useContext } from 'react';

import Button3D from '@/components/game/3d/object/button/Button3D';
import BatteryComposed from '@/components/game/3d/object/piece/BatteryComposed';
import { GameContext, ViewContext } from '@/state/contexts';
import { buyBattery } from '@lc/const/socketEvent';
import { calculateBatteryCost } from '@lc/lib/playermat_helper';
import { logg } from '@/util/logg';

// IF possible to buy (right player, can afford it) display buy button

const BatteryBuilder = ({ batteries, playerId, payForAction }) => {
	if (batteries == null) return null;
	// create element at position-x = n * 1.5  for each numBattery

	const {
		myState,
		isTutorial,
		stepTutorial,
		setStepTutorial,
		// setSelectedAction,
		// setSelectedActionCost,
		// performAction,
	}: any = useContext(GameContext);

	const {
		pPE,
		pPC,

		// showPaymentModal,
		// setShowPaymentModal,
		currentTickerTimer,
		setCurrentTickerIndex,
	}: any = useContext(ViewContext);

	const BatteryArray: any = [];

	for (let i = 0; i < batteries; i++) {
		BatteryArray.push(
			<BatteryComposed key={`battery_${playerId}_${i}`} index={i} />
		);
	}

	function clientBuyBattery() {
		const batteryCost = calculateBatteryCost(myState);
		payForAction(buyBattery, batteryCost);

		if(isTutorial && stepTutorial === 16){
			setStepTutorial((prev) => prev + 1);
			clearTimeout(currentTickerTimer);
			setCurrentTickerIndex((prev) => prev + 1);
		}
	}

	function getOffset() {
		return (batteries - 2) * 1.45;
	}

	return (
		<group key={`battery_group_${playerId}`} position={[-2, 5.5, 14.75]}>
			{BatteryArray}
			{batteries < 6 && pPE + pPC >= (myState.batteries >= 1 ? 2 : 1) && (
				<Button3D
					buttonAction={clientBuyBattery}
					playerId={playerId}
					p={[3 + getOffset(), 0, -0.75]}
				/>
			)}
		</group>
	);
};

export default BatteryBuilder;
